// Auto-generated from translation.csv; do not edit manually
export const ruRU = {
  "accountGuide": {
    "content": "Откройте любую игру Touka, перейдите на главный экран игры, привяжите свою электронную почту и получайте скидки на специальные товары!",
    "title": "Как создать аккаунт?"
  },
  "bottomNav": {
    "home": "Главная",
    "myOrders": "Мои заказы"
  },
  "common": {
    "loading": "Загрузка...",
    "noData": "Нет данных",
    "server": "Сервер"
  },
  "auth": {
    "tokenExpired": "Срок действия входа истёк"
  },
  "errors": {
    "900400": "Ошибка внутренних параметров",
    "900401": "Ошибка аутентификации",
    "900402": "Срок действия входа истёк",
    "1000000": "Системная ошибка. Повторите попытку позже",
    "1000001": "Ошибка системных параметров. Повторите попытку позже",
    "1000002": "Введите ID капчи или код",
    "1000003": "Недействительный адрес электронной почты",
    "1000004": "Недействительный код капчи",
    "1000005": "Код уже отправлен. Подождите 1 минуту и повторите попытку",
    "1000006": "Достигнут лимит отправки кода. Повторите попытку завтра",
    "1000007": "Введите адрес электронной почты",
    "1000008": "Введите код",
    "1000009": "Недействительный код",
    "1000010": "Не удалось получить токен входа",
    "1000011": "Товар неактивен. Выберите другой товар",
    "1000012": "Превышен лимит покупки товара. Выберите другой товар",
    "1000013": "Товар снят с продажи",
    "1000014": "Способ оплаты не включён",
    "1000015": "Ваш аккаунт не поддерживает покупку товаров. Обратитесь в службу поддержки",
    "1000016": "Не удалось создать заказ. Повторите попытку",
    "1000017": "Этот заказ нельзя отменить",
    "1000018": "Достигнут лимит количества для одной покупки",
    "1000019": "Код подтверждения истек. Запросите новый"
  },
  "footer": {
    "language": "Китайский (упрощённый)",
    "privacyPolicy": "Политика конфиденциальности",
    "refundPolicy": "Политика возврата",
    "termsOfService": "Условия обслуживания",
    "userSupport": "Поддержка пользователей",
    "downloadNow": "Скачать сейчас!"
  },
  "header": {
    "characterName": "Имя персонажа",
    "gameServer": "Игровой сервер",
    "selectGameServer": "Выберите регион игры",
    "greeting": "Здравствуйте",
    "loginPrompt": "Пожалуйста, нажмите для входа",
    "switchServer": "Переключить",
    "title": "Центр пополнения игры",
    "logout": "Выйти"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Упс! Кроко"
  },
  "history": {
    "backToGameZone": "Вернуться в магазин игры",
    "allGames": "Все игры",
    "empty": "Нет заказов",
    "filter": {
      "all": "Все",
      "closed": "Закрытые",
      "completed": "Завершённые",
      "inProgress": "В процессе",
      "pendingDelivery": "Ожидает отправки"
    },
    "orderTime": "Время заказа:",
    "pendingAutoCancelPrefix": "Заказ будет отменён через",
    "pendingAutoCancelSuffix": "автоматически",
    "cancelOrder": "Отменить заказ",
    "payOrder": "Оплатить",
    "cancelOrderConfirmTitle": "Подтвердить отмену заказа?",
    "cancelOrderConfirmPrimary": "Подтвердить",
    "cancelOrderDismiss": "Не сейчас",
    "previousPage": "Назад",
    "nextPage": "Далее",
    "status": {
      "cancelled": "Закрыт",
      "completed": "Сделка завершена",
      "paid": "Оплачено",
      "pending": "Ожидает оплаты",
      "refunded": "Возврат выполнен",
      "shipped": "Отправлено"
    }
  },
  "home": {
    "selectGame": "Выберите игру для пополнения",
    "selectGameMobileTitle": "Выбор игры для пополнения",
    "mobileGameCardGo": "Перейти",
    "selectGameParts": {
      "prefix": "Выберите игру для ",
      "keyword": "пополнения",
      "suffix": ""
    },
    "purchaseEntryParts": {
      "prefix": "Перейти к ",
      "keyword": "покупке",
      "suffix": ""
    },
    "noRoleAccount": "У вас ещё нет персонажа в этой игре. Создайте персонажа в игре перед покупкой.",
    "noRoleRefreshPrefix": "Уже создали аккаунт? Нажмите ",
    "noRoleRefreshAction": "Обновить",
    "noRoleRefreshing": "Обновление…",
    "noRoleRefreshNotFound": "Информация о персонаже не найдена",
    "noRoleRefreshFailed": "Не удалось обновить. Попробуйте позже."
  },
  "login": {
    "agreeTerms": {
      "and": "и",
      "prefix": "Я прочитал(а) и соглашаюсь с",
      "privacy": "Политикой конфиденциальности",
      "terms": "Условиями обслуживания"
    },
    "cancel": "Отмена",
    "bindGameGuide": "Справка по привязке игры",
    "bindGameGuideContent": "Откройте любую игру Touka,\nзайдите в настройки внутри игры,\nпривяжите почту —\nи пользуйтесь специальными ценами в магазине!",
    "captchaPlaceholder": "Код подтверждения",
    "invalidCaptcha": "Пожалуйста, введите 4-значный код подтверждения",
    "email": "Электронная почта",
    "emailNotBound": "Не удалось найти аккаунт. Пожалуйста, введите адрес электронной почты, привязанный к игровому аккаунту~",
    "emailPlaceholder": "Пожалуйста, введите ваш электронный адрес",
    "keepLogin": "Сохранить вход в системе на 15 дней",
    "loading": "Вход...",
    "loginToStore": "Вход в Touka Store",
    "noAccount": "Ещё нет аккаунта?",
    "password": "Пароль",
    "passwordPlaceholder": "Пожалуйста, введите пароль",
    "submit": "Войти",
    "title": "Войти",
    "invalidEmail": "Введите действительный адрес электронной почты"
  },
  "logout": {
    "cancel": "Отменить",
    "confirm": "Подтвердить",
    "dontRemind": "Больше не напоминать",
    "messageLine1": "После выхода из аккаунта статус входа на всех устройствах, использованных за последние 30 дней,",
    "messageLine2": "будет сброшен.",
    "title": "Важное уведомление"
  },
  "menu": {
    "contactSupport": "Связаться с поддержкой",
    "gameList": "Список игр",
    "myOrders": "Мои заказы"
  },
  "paymentSuccess": {
    "account": "Аккаунт:",
    "celebrationTitle": "Покупка успешна",
    "confirm": "Подтвердить",
    "getPaymentInfoFailed": "Не удалось получить информацию об оплате",
    "loading": "Загрузка...",
    "orderDate": "Дата заказа:",
    "orderId": "Номер заказа:",
    "paymentMethod": "Способ оплаты:",
    "paypal": "PayPal",
    "price": "Цена:",
    "purchaseContent": "Содержание покупки:",
    "quantity": "Количество покупки:",
    "serverAndCharacter": "Кластер/Персонаж:",
    "title": "Спасибо за покупку",
    "total": "Итого:",
    "unionPay": "UnionPay",
    "amountPaid": "Сумма к оплате:",
    "closeModal": "Закрыть"
  },
  "productModal": {
    "confirm": "Подтвердить",
    "purchaseDetails": "Детали покупки",
    "quantity": "Количество:",
    "total": "Итого:",
    "unitPrice": "Цена за единицу:"
  },
  "products": {
    "giftPacks": "Пакет",
    "diamond": "Бриллиант",
    "products": "Товар",
    "vouchers": "Ваучер",
    "toukaCoin": "Touka Coin",
    "toukaCoinBonusTip": "Покупайте в TOUKA Store и получайте дополнительно 10% награды!",
    "superValue": "Выгодно",
    "limitShort": "Лимит",
    "remainingShort": "Осталось",
    "giftPackLimitType": {
      "lifetime": "Навсегда",
      "weekly": "Еженедельно",
      "monthly": "Ежемесячно"
    },
    "howToUseVouchers": "Как использовать Touka Coin?",
    "voucherGuide": {
      "title": "Как использовать Touka Coin?",
      "step1": "1. Получите приобретённые Touka Coin во внутриигровой почте.",
      "step2": "2. Баланс Touka Coin можно посмотреть в верхней части вкладки внутриигрового магазина. Когда Touka Coin будет достаточно для покупки набора, при оплате они будут использованы в первую очередь.",
      "backToProducts": "Вернуться к списку товаров"
    },
    "luxuryVouchers": "Премиальные ваучеры"
  },
  "purchaseConfirm": {
    "card": "Кредитная/дебетовая карта",
    "confirm": "Подтверждение",
    "dontAskAgain": "Не спрашивать в течение 30 дней",
    "gameServer": "Игровой кластер",
    "paymentMethods": "Поддерживаемые способы оплаты",
    "paypal": "PayPal",
    "title": "Вы уверены, что хотите совершить покупку с этого аккаунта?",
    "unionPay": "Карта UnionPay"
  },
  "serverSelect": {
    "characterLabel": "Имя персонажа",
    "characterPlaceholder": "Пожалуйста, выберите персонажа",
    "confirm": "Подтвердить",
    "noResults": "Результатов нет",
    "serverPlaceholder": "Пожалуйста, введите название сервера для поиска",
    "title": "Выберите игровой сервер"
  },
  "orientation": {
    "bestExperience": "Для лучшего просмотра переключитесь в портретный режим"
  },
  "support": {
    "cancel": "Отмена",
    "copied": "Скопировано",
    "copy": "Скопировать одним кликом",
    "description": "Пожалуйста, отправьте подробную информацию на официальный адрес поддержки.",
    "title": "Служба поддержки"
  },
  "verification": {
    "back": "Назад",
    "enterCode": "Пожалуйста, введите код подтверждения для продолжения",
    "incorrectCode": "Неверный код подтверждения",
    "invalidCode": "Пожалуйста, введите 6-значный код подтверждения",
    "noCode": "Не получаете код?",
    "sentTo": "Код подтверждения отправлен на",
    "submit": "Отправить",
    "submitting": "Отправляется..."
  }
} as const;
